import { Component, EventEmitter, Output } from "@angular/core";
import { NavigationService } from "src/services/navigation/navigation.service";
import { MessageService } from "src/services/message/message.service";
import { isRackQrCode } from "src/services/qr-code/qr-code.interface";
import { Rack } from "src/services/item/rack.interface";

@Component({
  selector: "rc-rack-scanner",
  templateUrl: "./rack-scanner.component.html",
  styleUrls: ["./rack-scanner.component.scss"],
  standalone: false,
})
export class RackScannerComponent {
  @Output() public onQrCodeScanned = new EventEmitter<Rack>();

  private processingCode = false;

  constructor(
    public readonly navigationService: NavigationService,
    private readonly messageService: MessageService,
  ) {}

  public async tryHandleQrCodeScanned(qrCodeString: string): Promise<void> {
    if (this.processingCode) {
      return;
    }

    this.processingCode = true;
    try {
      this.onQrCodeScanned.emit(await this.getRackFromQrCodeOrThrow(qrCodeString));
    } catch (error) {
      await this.messageService.presentErrorToast(error.message);
    } finally {
      this.processingCode = false;
    }
  }

  private async getRackFromQrCodeOrThrow(qrCodeString: string): Promise<Rack> {
    let qrCode: unknown;
    try {
      qrCode = JSON.parse(qrCodeString);
    } catch {
      await this.messageService.presentErrorToast("This QR code can't be read");
    }

    if (!isRackQrCode(qrCode)) {
      throw new Error("This QR code doesn't contain rack information");
    }

    return qrCode;
  }
}
